module.exports = __webpack_public_path__ + "static/media/landingPageVideo2FR.c04101e1.webp";